module.exports = __webpack_public_path__ + "static/media/funda3.6cc8fb10.jpg";